// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3__xt","field":"styles_field__2AUt5","fieldCol":"styles_fieldCol__2Ds67","diffCol":"styles_diffCol__2wWTe","diff":"styles_diff__1WE4v"};